<template>
  <div class="d-flex flex-column">
    <input
      :placeholder="placeholder"
      v-mask="mask"
      :class="[
        type === 'date' ? 'input_date' : '',
        error ? '-error' : ''
      ]"
      :type="type"
      :disabled="disabled"
      :value="val"
      @input="input"
      @blur="$emit('blur')"
      class="input"
    >
    <span
      v-if="errorText"
      v-text="errorText"
      class="error-text"
    />
  </div>
</template>

<script>
/**
 * Поддерживаемые типы: text, date, email
 */
export default {
  name: 'SInput',
  model: {
    prop: 'val',
    event: 'input',
  },
  props: {
    val: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    mask: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorText: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
  },
  computed: {
    dynamicMask () {
      if (!this.mask) {
        return null
      }

      return { [`v-mask`]: this.mask }
    },
  },
  methods: {
    input ($e) {
      this.$emit('input', $e.target.value)
    },
  },
}
</script>

<style lang="less">
.input {
	width: 100%;
	height: 45px;
	display: flex;
	align-items: center;
	background-color: #F9F9F9;
	padding: 10px 18px;
	border: none;
	border-radius: 10px;
	font-family: 'Roboto', Arial, sans-serif;
	font-size: 14px;
	color: black;

	&.-error {
		border: 1px solid red;
	}

	&::placeholder {
		font-family: 'Roboto', Arial, sans-serif;
		font-size: 14px;
		color: black;
	}

	&:disabled {
		opacity: .75;
		cursor: default;
	}
}

.error-text {
	font-size: 11px;
	color: red;
	margin-top: 4px;
}
</style>
